// For fuel charging
export const bookingProcessAliasFuelCharging = 'fuel-charging/payouts-1.0';
export const TRANSITION_FUEL_CHARGING_REQUEST = 'transition/fuel-charge-request';
export const TRANSITION_FUEL_CHARGING_CONFIRM_PAYMENT = 'transition/fuel-charge-confirm-payment';
export const LINE_ITEM_FUEL_CHARGING_PROVIDER_COMMISSIONS = 'line-item/fuel-charging-provider-commissions';
export const LINE_ITEM_FUEL_CHARGING_DRIVELAH_COMMISSIONS = 'line-item/fuel-charging-drivelah-commissions';
